import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pill, CUIText } from '@dotcom/crown-ui';
import styles from '../../select-envelope.module.scss';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header className={styles['envelope-card-header']}>
      <CUIText variant="h5" as="h2" className={styles.title}>
        {t('envelopeSelection.title')} <Pill title="Free!" className={styles['pill-element']} />
      </CUIText>
      <CUIText as="span" color="textPrimary">
        {t('envelopeSelection.description')}
      </CUIText>
    </header>
  );
};
